import React from 'react';
import styles from './pfNoResult.scss'
import * as helper from '../../../Common/html-helper';
import classNames from 'classnames';
import IPfNoResult from './pfNoResult.d';
import TabNavigationHelper from '../../../Common/tabNavigationHelper';

function NoResult({ l10n, finderType }: IPfNoResult) {
    const handleFinderClick = React.useCallback(() => {
        window.shell.publishTo('ESPP.MainSidePanel.ShouldOpen', `ESPP1-${finderType}Web`);
    }, [finderType]);

    const tabNav = TabNavigationHelper.instance;

    return (
        <div className={styles.no_pf_result}>
            <div className={styles.headline}>{helper.decodeHTML(l10n.hint)}</div>
            <div dangerouslySetInnerHTML={{ __html: l10n.pfNoResult }}/>
            <div ref={(el)=>tabNav.setFocusAtt(el)}
                className={classNames(styles.button, styles.edit_filter_btn)}
                data-testid='pf_edit_filter_btn'
                data-semantic-id='pf_edit_filter_btn'
                onClick={handleFinderClick}>
                {helper.decodeHTML(l10n.goToProductFinder)}
                <div className={styles.arrow} />
            </div>
        </div>
    );
}

export default NoResult;

